// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import {
  Overlay,
  StockText,
  StockIndicatorWrapper,
  SolidCircle,
  OutlineCircle,
} from '../styles/StockIndicator.style';

const StockIndicator = ({
  isDimmed,
  oosBgColor,
  isOutOfStock,
  oosTextColor,
  showOosOverlay,
  oosOverlayText,
}) => {
  if (showOosOverlay && isOutOfStock) {
    return (
      <Overlay oosBgColor={oosBgColor}>
        <StockText oosTextColor={oosTextColor}>{oosOverlayText}</StockText>
      </Overlay>
    );
  }

  return !isOutOfStock ? (
    <StockIndicatorWrapper isDimmed={isDimmed}>
      <OutlineCircle />
      <SolidCircle />
    </StockIndicatorWrapper>
  ) : null;
};

StockIndicator.propTypes = {
  isDimmed: PropTypes.bool,
  oosBgColor: PropTypes.string,
  showOosOverlay: PropTypes.bool,
  oosTextColor: PropTypes.string,
  stockVisible: PropTypes.shape({}),
  isOutOfStock: PropTypes.bool.isRequired,
  oosOverlayText: PropTypes.string.isRequired,
};

StockIndicator.defaultProps = {
  oosBgColor: '',
  isDimmed: false,
  oosTextColor: '',
  stockVisible: {},
  showOosOverlay: false,
};

export default StockIndicator;
